import { getAuthToken } from "@/lib/auth";
import { API_ENDPOINT } from "@/lib/constants";
import { paths } from "@/lib/openapi";
import { atom, computed } from "nanostores";
import createClient from "openapi-fetch";

export const authToken = atom<string | undefined>();
const token = getAuthToken();
if (token) {
  authToken.set(token);
}

export const client = computed(authToken, (currentToken) =>
  createClient<paths>({
    headers: currentToken ? { Authorization: `Bearer ${currentToken}` } : {},
    baseUrl: API_ENDPOINT,
  })
);

export const noAuthClient = createClient<paths>({
  baseUrl: API_ENDPOINT,
});
